import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { ROLE_IN_RELATIONSHIP_OPTIONS } from '@/pages/Onboarding/options/RoleInRelationship/ROLE_IN_RELATIONSHIP_OPTIONS.ts';
import { getRoleInRelationshipTitleById } from '@/pages/Onboarding/options/RoleInRelationship/utils/getRoleInRelationship';
import { OnbOptionType } from '@/pages/Onboarding/types.ts';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const RoleInRelationshipScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'RoleInRelationship',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const role = form.watch('role_in_relationship');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['role_in_relationship']>,
  ) => {
    form.setValue('role_in_relationship', option.id);
  };

  const handleNextStep = () => {
    const roleTitle = getRoleInRelationshipTitleById(role);
    userService.createOrUpdate({
      onboarding_data: {
        role_in_relationship: roleTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What's His Role In The Relationship?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {ROLE_IN_RELATIONSHIP_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={role === option.id}
              control={form.control}
              option={option}
              name="role_in_relationship"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!role}
      />
    </OnboardingPage>
  );
};
